import { render, staticRenderFns } from "./AppleWallet.vue?vue&type=template&id=529cce6c&"
import script from "./AppleWallet.vue?vue&type=script&lang=js&"
export * from "./AppleWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports